module.exports = __webpack_public_path__ + "img/tick-square.aef775c9.svg";